import { useState, useEffect } from "react";

import modalIcon from "../../assets/badgeIcon.png";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ClipboardCopy from "../ClipboardCopy/ClipboardCopy";


//Modal
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
//MUI
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import CheckIcon from "@mui/icons-material/Check";
import { postBadge } from "../../Services/apiClient";
import { getUserBadges } from "../../Services/apiClient";
//import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { getUser } from "../../Services/apiClient";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Breakpoints
import breakPoints from "../../breakpoints";
console.log(breakPoints.device.s);
function CreateBadge() {
  const [open, setOpen] = useState(false);
  const [openWrong, setOpenWrong] = useState(false);
  const [state, setState] = useState({
    badgename: "",
    receiver: "",
    info: "",
    date: new Date(),
    image: "",

    badgeId: "",
  });

  //Modal
  const handleOpen = () => setOpen(true);
  //need to also resen uploader
  const handleClose = () => {
    setState({
      ...state,
      date: new Date(),
      badgeId: "",
      badgename: "",
      receiver: "",
      info: "",
      image: "",
    });
    setOpen(false);
  };

  //sets value for date picker
  const handleDateChange = (newValue) => {
    setState({ ...state, date: newValue });
  };

  //console.log('this is the date', value);

  const handleChange = (e) => {
    e.preventDefault();
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const postNewBadge = async () => {
    if (state.badgename === "" || state.receiver === "" || state.image === "") {
      setOpenWrong(true);
    } else {
      
      const formattedDate =state.date.toISOString().slice(0, 10);
    

      const result = await postBadge(
        "firestore/badges",
        state.badgename,
        formattedDate,
        state.receiver,
        state.info,
        state.image
      );

      console.log(result);
      setState({ ...state, badgeId: result });
      handleOpen();
    }
  };

  const getCurrentUser = async () => {
    const user = await getUser("firestore/whoAmI");
    setState({ ...state, currentUser: user });
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    /* console.log(base64) */
    setState({ ...state, image: base64 });
    event.target.value = null;
  };

  const handleCloseWrong = () => {
    setOpenWrong(false);
  };
  return (
    <>
   
      {state.currentUser && state.currentUser.role === "admin" && (
        <>
          <div>
            {/* Modal */}
            <Modal
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <Box sx={style}>
                  <Typography
                    id="transition-modal-title"
                    variant="h4"
                    component="h2"
                    mt={3}
                    mb={5}
                    sx={{
                      color: "#1f1f1f",
                      fontSize: "1.3rem",
                      fontWeight: "500",
                    }}
                  >
                    The badge was successfully created!{" "}
                  </Typography>

                  <img
                    style={{ width: "30%" }}
                    id="badge-icon"
                    src={modalIcon}
                    alt="badge-icon"
                  />
                  <ClipboardCopy
                    copyText={`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${
                      state.badgename
                    }&organizationId=10867066&certId=${
                      state.badgeId
                    }&certUrl=${`badges.geshdo.dev/badge/${state.badgeId}`}&issueYear=${state.date.getFullYear()}&issueMonth=${
                      state.date.getMonth() + 1
                    }`}
                  />
                </Box>
              </Fade>
            </Modal>
          </div>
          {/* Modal ends here */}
          {/*Warning modal starts */}
          <div>
            <Modal
              open={openWrong}
              onClose={handleCloseWrong}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={styleWarning}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                  Wrong information
                </Typography>
                <Typography
                  id="modal-modal-description"
                  sx={{ mt: 2, fontSize: "1.5em" }}
                >
                  Please, fill in all the fields in the form
                </Typography>
              </Box>
            </Modal>
          </div>
          {/*Warning modal ends */}
  
          <StyledHomeContainer>
        
            <div className="hero">
              {/* <button onClick={postNewBadge}>Send</button>{' '} */}
              <div>
                <form>
                  <Typography
                    variant="h1"
                    component="h2"
                    id="form-title"
                    mb={5}
                    sx={{
                      color: "#fdfdfd",
                      fontSize: "2.2rem",
                      fontWeight: "500",
                   
                    }}
                  >
                    Create badge.
                  </Typography>

                  <div className="inputbox">
                    <StyledTextField
                      sx={{}}
                      required
                      color="secondary"
                      focused
                      className="input"
                      id="outlined-basic"
                      label="Badge Name"
                      variant="outlined"
                      type="text"
                      name="badgename"
                      // helperText='Name of the badge'
                      value={state.badgename}
                      onChange={handleChange}
                    />

                    <StyledTextField
                      required
                      color="secondary"
                      focused
                      className="input"
                      id="outlined-basic"
                      label="Receiver"
                      variant="outlined"
                      type="text"
                      name="receiver"
                      // helperText='Year when badge is isssued'
                      value={state.receiver}
                      onChange={handleChange}
                    />

                    {/* Fix value for date */}
                    <DatePicker
                      label="Date"
                      inputFormat="MM/dd/yyyy"
                      value={state.date}
                      onChange={handleDateChange}
                      renderInput={(params) => {
                        return (
                          <StyledTextField
                            required
                            focused
                            color="secondary"
                            value={params.inputProps.value}
                            {...params}
                            style={{
                              background: "#1c1c25",
                              borderRadius: "10px",
                            }}
                          />
                        );
                      }}
                    />
                  </div>
                  <div>
                    <div className="input_and_img">
                      <TextareaAutosize
                        type="text"
                        label="info"
                        required
                        name="info"
                        value={state.info}
                        variant="standard"
                        placeholder="Information about badge here..."
                        onChange={handleChange}
                        //InputProps={{ style: { fontSize: '4rem' } }}
                        style={{
                          width: 250,
                          height: 100,
                          borderColor: "#d9d8d8",
                          color: "#d9d8d8",
                          borderWidth: 1,
                          marginBottom: "3rem",
                          background: "#1c1c25",
                          borderRadius: "10px",
                          padding: "10px",
                          fontSize: "1rem",
                          fontFamily: "Roboto",
                        }}
                      />

                      {state.image !== "" ? (
                        <div className="uploaded-img-box" style={{}}>
                          <img
                            className="uploaded-image"
                            src={state.image}
                            alt=""
                            // style={style.img}
                          />
                        </div>
                      ) : null}
                    </div>

                    <div className="button-box">
                      <Button
                        startIcon={<UploadFileIcon />}
                        variant="contained"
                        component="label"
                        sx={{
                          marginBottom: "2rem",
                          background: "#5295BF",
                          "&:hover": {
                            background: "#3e7394",
                          },
                        }}
                      >
                        Upload file
                        <TextField
                          id="originalFileName"
                          type="file"
                          inputProps={{ accept: "image/*, .pdf, .png" }}
                          required
                          label="Document"
                          name="originalFileName"
                          onChange={(e) => handleFileRead(e)}
                          // size='small'
                          variant="standard"
                          sx={{ display: "none" }}
                        />
                      </Button>
                      <Button
                        sx={{
                          padding: 1.5,
                          width: "16rem",
                          color: "#fdfdfd",
                          background: "#b83c97",
                          "&:hover": {
                            background: "#932f78",
                          },
                        }}
                        // type='submit'
                        onClick={postNewBadge}
                        // color='secondary'
                        variant="contained"
                        // style={{ border: '2px solid' }}
                        startIcon={<CheckIcon />}
                      >
                        Create Badge
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </StyledHomeContainer>
        </>
      )}

      {state.currentUser && state.currentUser.role === "user" && (
        <>
          <div className="noPerm" style={style.noPerm}>
            <h5 style={{ color: "white" }}>
              Oops, seems like you don't have permission to view this page
            </h5>
          </div>
        </>
      )}
    </>
  );
}

const style = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  width: 450,
  height: 400,
  backgroundColor: "#fdfdfd !important",
  p: 4,
  borderRadius: "10px",
  border: "6px solid #9545b1 !important",
  color: "#0d0d0d !important",
  img: {
    width: "100%",
  },
  noPerm: {
    textAlign: "center",
    fontSize: "5vh",

    marginTop: "45vh",
  },
};

const styleWarning = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  textAlign: "center",

  backgroundColor: "#fdfdfd !important",
  p: 4,
  borderRadius: "10px",
  border: "6px solid #9545b1 !important",
  color: "#0d0d0d !important",
};

const StyledHomeContainer = styled.div`
  height: 100vh;
  display: flex;
  /* align-items: center; */
  justify-content: center;

  svg {
    color: #fdfdfd;
  }

  .hero {
    display: grid;

    align-items: center;
    justify-content: center;
    padding: 4rem;
    width: 50vw;
    height: 80vh;
    background: #010110b3;
    backdrop-filter: blur(8px);
    border-radius: 20px;
    border: 2px solid #fdfdfd;
    margin: auto;
    box-shadow: 0px 20px 30px 0px #06040d78;
  }

  .input {
    margin: 0 3rem 3rem 0;
  }

  .input_and_img {
    display: flex;
    width: 50vh;
    margin-top: 2.5rem;
  }

  .uploaded-img-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 8rem;
    border-radius: 5px;
    background: #fdfdfd;
    margin-left: 4rem;
  }

  .uploaded-image {
    width: 80%;
    padding: 0.9rem;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fdfdfd;
    border-radius: 5px;
    height: 7rem;
    padding: 3rem;
  }

  .badge {
    width: 3rem;
  }

  .button-box {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  //Breakpoints
  @media ${breakPoints.device.xs} {
    .hero {
      padding: 1rem 1.2rem;
    }
    .input_and_img {
      flex-direction: column;
      width: 100%;
    }
    .uploaded-img-box {
      margin: 0 0 2rem 0;
      height: 60px;
    }
    .uploaded-image {
      width: 80%;
    }
  }

  @media ${breakPoints.device.s} {
    .hero {
      width: 95vw;
      height: 85vh;
    }
    .input_and_img {
      flex-direction: column;
      width: 100%;
    }
    .uploaded-img-box {
      margin: 0 0 2rem 0;
      height: 60px;
    }
    .uploaded-image {
      width: 80%;
    }
  }

  @media (min-width: 2000px) {
    .hero {
      width: 35vw;
      height: 55vh;
    }
    // custom CSS
  }
`;

const StyledTextField = styled(TextField)`
  & label.Mui-focused {
    color: #d9d8d8;
  }
  & input {
    color: #d9d8d8;
    background: #1c1c25;
    border-radius: 10px;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #d9d8d8;
      border-width: 1px;
      border-radius: 10px;
      color: #d9d8d8;
    }
  }
`;

export default CreateBadge;
